(function () {
  const CLIP_COLLAPSED = 'is-collapsed';
  const BLOCK_EXPANDED = 'cap-section-block--body-expanded';

  function initTruncate(root) {
    if (root.dataset.brandAtPerfTruncateInit === '1') {
      return;
    }
    root.dataset.brandAtPerfTruncateInit = '1';

    const clip = root.querySelector('.cap-section-body-clip');
    const body = root.querySelector('.cap-section-body');
    const btn = root.querySelector('.cap-section-read-more');
    const liveRegion = root.querySelector('[data-brand-at-perf-live]');
    const block = root.closest('.cap-section-block');
    if (!clip || !body || !btn || !block) {
      return;
    }

    const content = block.querySelector('.cap-section-content');
    const colImg = block.querySelector('.cap-section-image img');

    const readMore = root.dataset.readMore || 'Read more';
    const readLess = root.dataset.readLess || 'Read less';
    const panel = root.closest('.accordion-panel');

    let resizeTimer = null;
    /** @type {number | null} */
    let raf = null;
    let zeroHeightRetries = 0;

    /**
     * Sets .cap-section-content height to match the rendered height of the
     * column image so the clip fills exactly that space.
     */
    function syncContentHeight() {
      if (!content || !colImg) return;
      const imgH = colImg.getBoundingClientRect().height;
      if (imgH > 0) {
        content.style.height = imgH + 'px';
      }
    }

    function scheduleMeasure() {
      if (raf !== null) {
        cancelAnimationFrame(raf);
      }
      raf = requestAnimationFrame(() => {
        raf = requestAnimationFrame(() => {
          raf = null;
          void runMeasureAfterFonts();
        });
      });
    }

    async function runMeasureAfterFonts() {
      try {
        if (document.fonts?.ready) {
          await document.fonts.ready;
        }
      } catch {
        // Still measure if font loading fails
      }
      measure();
    }

    /** Returns true when the viewport matches the mobile breakpoint. */
    function isMobile() {
      return window.innerWidth <= 768;
    }

    /**
     * @param {boolean} expanded
     */
    function announceLabel(label) {
      if (!liveRegion) { return; }
      liveRegion.textContent = '';
      setTimeout(function () {
        liveRegion.textContent = label;
      }, 250);
    }

    function hideOverflowContent(collapsed) {
      const container = body.querySelector('.metafield-rich_text_field') || body;
      for (let i = 0; i < container.children.length; i++) {
        const child = container.children[i];
        if (collapsed && i >= 2) {
          child.style.display = 'none';
          child.setAttribute('aria-hidden', 'true');
          child.setAttribute('tabindex', '-1');
          var focusables = child.querySelectorAll('a, button, input, select, textarea, [tabindex]');
          for (var j = 0; j < focusables.length; j++) {
            focusables[j].setAttribute('aria-hidden', 'true');
            focusables[j].setAttribute('tabindex', '-1');
          }
        } else {
          child.style.display = '';
          child.removeAttribute('aria-hidden');
          child.removeAttribute('tabindex');
          var focusables = child.querySelectorAll('a, button, input, select, textarea, [tabindex]');
          for (var j = 0; j < focusables.length; j++) {
            focusables[j].removeAttribute('aria-hidden');
            focusables[j].removeAttribute('tabindex');
          }
        }
      }
    }

    function setExpandedUi(expanded) {
      const mobile = isMobile();
      if (expanded) {
        block.classList.add(BLOCK_EXPANDED);
        clip.classList.remove(CLIP_COLLAPSED);
        block.style.height = 'auto';
        block.style.maxHeight = 'none';
        if (content) content.style.height = '';
        btn.textContent = readLess;
        announceLabel('Read less about Giorgio armani');
        hideOverflowContent(false);
        return;
      }
      block.classList.remove(BLOCK_EXPANDED);
      clip.classList.add(CLIP_COLLAPSED);
      block.style.height = '';
      block.style.maxHeight = '';
      if (!mobile) syncContentHeight();
      else if (content) content.style.height = '';
      btn.textContent = readMore;
      announceLabel('Read more about Giorgio armani');
      hideOverflowContent(true);
    }

    function measure() {
      if (panel?.hidden) {
        return;
      }

      const userExpanded = block.classList.contains(BLOCK_EXPANDED);
      const mobile = isMobile();

      hideOverflowContent(false);

      block.classList.remove(BLOCK_EXPANDED);
      clip.classList.add(CLIP_COLLAPSED);
      // Desktop: reset so colImg can render at natural size before syncing
      // Mobile: clear any stale inline height — CSS handles clipping
      if (content) content.style.height = '';

      requestAnimationFrame(() => {
        // Desktop only: sync content height to the image's rendered height
        if (!mobile) syncContentHeight();

        if (clip.clientHeight < 1 && body.scrollHeight > 0) {
          clip.classList.remove(CLIP_COLLAPSED);
          if (userExpanded) {
            block.classList.add(BLOCK_EXPANDED);
          }
          if (zeroHeightRetries < 8) {
            zeroHeightRetries += 1;
            setTimeout(scheduleMeasure, 100);
          }
          return;
        }

        zeroHeightRetries = 0;

        const overflows = body.scrollHeight > clip.clientHeight + 2;

        if (!overflows) {
          clip.classList.remove(CLIP_COLLAPSED);
          block.classList.remove(BLOCK_EXPANDED);
          block.style.height = '';
          block.style.maxHeight = '';
          // Desktop only: keep content height synced to image
          if (!mobile) syncContentHeight();
          else if (content) content.style.height = '';
          btn.hidden = true;
          return;
        }

        btn.hidden = false;
        setExpandedUi(userExpanded);
      });
    }

    function onButtonClick() {
      setExpandedUi(!block.classList.contains(BLOCK_EXPANDED));
    }

    function onWindowResize() {
      if (resizeTimer !== null) {
        clearTimeout(resizeTimer);
      }
      resizeTimer = window.setTimeout(() => {
        resizeTimer = null;
        scheduleMeasure();
      }, 150);
    }

    /**
     * Runs after `accessible-accordion` updates `hidden` / aria (toggle uses click or keydown).
     */
    function onAccordionMayHaveToggled(event) {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      if (!target.closest('.accordion-trigger')) {
        return;
      }
      requestAnimationFrame(() => {
        scheduleMeasure();
      });
    }

    btn.addEventListener('click', onButtonClick);

    for (const img of body.querySelectorAll('img')) {
      if (img.complete) {
        continue;
      }
      img.addEventListener('load', scheduleMeasure);
      img.addEventListener('error', scheduleMeasure);
    }

    // Re-measure when the column image loads — content height depends on it
    if (colImg && !colImg.complete) {
      colImg.addEventListener('load', scheduleMeasure);
      colImg.addEventListener('error', scheduleMeasure);
    }

    const accordion = panel?.closest('accessible-accordion');
    if (accordion) {
      accordion.addEventListener('click', onAccordionMayHaveToggled);
      accordion.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }
        onAccordionMayHaveToggled(event);
      });
      if (!panel.hidden) {
        scheduleMeasure();
      }
    } else {
      scheduleMeasure();
    }

    window.addEventListener('resize', onWindowResize);
    window.addEventListener('orientationchange', onWindowResize);
  }

  function boot() {
    for (const root of document.querySelectorAll('[data-brand-at-perf-truncate]')) {
      if (root instanceof HTMLElement) {
        initTruncate(root);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
